import { GET_STYLE_SHOT_REQUEST,
	GET_STYLE_SHOT_SUCCESS,
	GET_STYLE_SHOT_ERROR } from "../actions/types";

export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_STYLE_SHOT_REQUEST:
			return {
				loading: true,
			};
		case GET_STYLE_SHOT_SUCCESS:
			return {
				...state,
				loading: false,
				payload
						};
		case GET_STYLE_SHOT_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};

		default:
			return state;
	}
}
